import React, { useMemo, useState } from 'react';
import clsx from 'clsx';
import IconClose from 'utils/icon/icon-close.svg';
import { formatCartLinesAjax } from 'utils/storefront/format-resource';

const availableTiers = window.TMW.discountTiers;

const DiscountTiers = ({ product, cart }) => {
  const [toggled, setToggled] = useState(false);
  const lines = cart?.mode === 'storefront' ? cart?.state?.lines : formatCartLinesAjax(cart?.state?.items);

  const qualifyingProducts = useMemo(() => {
    return lines.reduce((acc, line) => {
      const lineProduct = cart.productsData[line.product_id];
      if (!lineProduct) return acc;
      return acc + (lineProduct.tags.includes('custom-set-eligible') ? line.quantity : 0);
    }, 0);
  }, [lines, cart.productsData]);

  const message = useMemo(() => {
    const count = qualifyingProducts;
    if (count >= window.TMW.discountTiers[window.TMW.discountTiers.length - 1]?.minProducts) {
      return window.TMW.Strings.discountTiers.maxDiscount.replace(
        '{discount}',
        window.TMW.discountTiers[window.TMW.discountTiers.length - 1].discountPercentage,
      );
    }
    if (count === 0) {
      return window.TMW.Strings.discountTiers.noProducts.replace(
        '{discount}',
        window.TMW.discountTiers[0].discountPercentage,
      );
    }

    for (const tier of availableTiers) {
      if (count >= tier.minProducts && count <= tier.maxProducts) {
        const nextTier = availableTiers.find((t) => t.minProducts > tier.maxProducts);
        if (nextTier) {
          return window.TMW.Strings.discountTiers[nextTier.minProducts - count > 1 ? 'multiple' : 'single'].replace(
            '{discount}',
            nextTier.discountPercentage,
          );
        }
      }
    }

    const firstTier = availableTiers[0];
    if (count < firstTier.minProducts) {
      return window.TMW.Strings.discountTiers[firstTier.minProducts - count > 1 ? 'multiple' : 'single'].replace(
        '{discount}',
        firstTier.discountPercentage,
      );
    }

    return null;
  }, [qualifyingProducts]);

  if (!product?.tags.includes('custom-set-eligible') || !message) {
    return null;
  }

  return (
    <div
      className="group/discounts rounded-md bg-grey-light open:px-5 open:py-4"
      open={toggled}
    >
      {toggled ? (
        <div className="relative flex flex-col">
          <button
            type="button"
            onClick={() => setToggled(false)}
            className="absolute right-0 top-0 size-3"
          >
            <IconClose />
          </button>
          <div
            className="rte [&>p>strong]:body-2-bold caption pr-3 [&>p:last-child]:mt-2 [&>p]:mb-0"
            dangerouslySetInnerHTML={{ __html: product?.buyMoreSaveMore }}
          ></div>
        </div>
      ) : (
        <div className={clsx('body-3-bold py-0.5')}>
          <div className="body-3-bold flex items-center justify-center gap-2 text-center">
            <div
              className={clsx({
                'text-error': qualifyingProducts > 0,
              })}
              dangerouslySetInnerHTML={{ __html: message }}
            ></div>
            <button
              className="underline"
              type="button"
              onClick={() => setToggled(true)}
            >
              {window.TMW.Strings.general.learnMore}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DiscountTiers;
